import { Creators } from '../ducks/geolocation';
import { put } from 'redux-saga/effects';
import { getLatLng } from '../../utils';
import store from '../../store';

export function* getGeolocation() {
  try {
    let data = {};
    
    const { lat, lng } = store.getState().geolocation;

    if (lat && lng) {
      data = { lat, lng };

      yield put(Creators.setGeolocation(data));

      return data;
    }

    data = yield getLatLng() || {};

    yield put(Creators.setGeolocation(data));

    return data;
  } catch (err) {
    console.log("[Geolocation] Error on getGeolocation", err);
  }
}